import { debounce } from './drawing';
/**
 * Module for window state & scroll/resize event hooks.
 * @module utils/window
 */

/** Watch and update window properties  */
const properties = {},
updateDimensions = _ => {
  properties.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  properties.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
},
updateScroll = _ => {
  properties.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  properties.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
  properties.scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
  properties.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
};
updateDimensions();
updateScroll();
window.addEventListener('load', _ => { updateDimensions(); updateScroll(); });
window.addEventListener('resize', _ => { updateDimensions(); updateScroll(); });
window.addEventListener('scroll', updateScroll);

/**
 * Returns all the above properties of the window object.
 * @returns {Object}
 */
export function getProperties() {
  return Object.assign({}, properties);
}

/**
 * Returns the width of the window in pixels.
 * @returns {Number}
 */
export function getWidth() {
  return properties.width;
}

/**
 * Returns the height of the window in pixels.
 * @returns {Number}
 */
export function getHeight() {
  return properties.height;
}

/**
 * Returns the top scroll value of the window in pixels.
 * @returns {Number}
 */
export function getScrollTop() {
  return properties.scrollTop;
}

/**
 * Returns the left scroll value of the window in pixels.
 * @returns {Number}
 */
export function getScrollLeft() {
  return properties.scrollLeft;
}

/**
 * Returns the scrollable width of the window in pixels.
 * @returns {Number}
 */
export function getScrollWidth() {
  return properties.scrollWidth;
}

/**
 * Returns the scrollable height of the window in pixels.
 * @returns {Number}
 */
export function getScrollHeight() {
  return properties.scrollHeight;
}

/**
 * Binds a series of events to an element. Sugar for HTMLElement.addEventListner.
 * @param {HTMLElement} element - The element top bind to.
 * @param {String} events - A space delimimetered list of events to binds (as with jQuery.bind).
 * @param {Function} callback - The callback function to bind.
 */
export function bindEvents(element, events, callback) {
  const eventKeys = events.split(' ');
  if (Array.isArray(eventKeys)) eventKeys.forEach(key => element.addEventListener(key, callback));
}

/**
 * Binds a debounced version of the passed callback to window.resize.
 * @param {Function} callback - The callback function to bind.
 * @returns {Function} - A function to unbind the events.
 */
export function onResize(callback) {
  window.addEventListener('resize', callback);
	return _ => window.removeEventListener('resize', cb);
}

/**
 * Binds a debounced version of the passed callback to window.scroll.
 * @param {Function} callback - The callback function to bind.
 * @returns {Function} - A function to unbind the events.
 */
export function onScroll(callback) {
  const cb = debounce(callback);
  window.addEventListener('resize', cb);
  window.addEventListener('scroll', cb);
  return _ => {
    window.removeEventListener('resize', cb);
    window.removeEventListener('scroll', cb);
  }
}


// WEBPACK FOOTER //
// ./source/scripts/utils/window.js